export const COMPONENT_CLASS = 'popular-widget';
export const POPULAR_EVENTS = 'c-popular-events';
export const POPULAR_TITLE = 'popular_events.title';
export const POPULAR_TITLE_ICON_CLASS_NAME = 'popular-events';

//Google Tag Manager
export const POPULAR_EVENT_GTM_TAG = 'popular-events-widget';
